import { render, staticRenderFns } from "./solicitud-reemplazo-correccion-jefe.vue?vue&type=template&id=36448472&"
import script from "./solicitud-reemplazo-correccion-jefe.vue?vue&type=script&lang=ts&"
export * from "./solicitud-reemplazo-correccion-jefe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports